module.exports = __webpack_public_path__ + "static/media/icmui_1200.c0134bc1.ico";